import { useIntl } from '@/intl'
import { useState } from 'react'

type PlanDetails = { hasSubscription: false } | { hasSubscription: true; planName: string }

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'settings.messagingPlan.view.headerTitle' }),
    subtitle: translate({ id: 'settings.messagingPlan.view.headerSubtitle' }),
    learnMoreLink: translate({ id: 'settings.messagingPlan.view.learnMoreLink' }),
    headerDescription: (planDetails: PlanDetails) =>
      planDetails.hasSubscription
        ? translate({
            id: 'settings.messagingPlan.view.headerDescription.sms',
            values: { planName: planDetails.planName },
          })
        : translate({ id: 'settings.messagingPlan.view.headerDescription.email' }),

    errorFetchingAccountData: translate({
      id: 'settings.messagingPlan.view.errorFetchingCommunicationPlanData',
    }),

    changePlan: translate({ id: 'settings.messagingPlan.view.changePlan' }),
    phoneNumbers: translate({ id: 'settings.messagingPlan.view.smsPlan.phoneNumbers' }),
  }))

  return api
}
